var process = require(/*! ./../../kru_node_modules/process/browser.js */"../../kru_node_modules/process/browser.js");
const config = require(/*! ../config */"../config.js");
const gameVersion = require(/*! ../../version.json */"../../version.json");

// KEY VALUES:
module.exports.keyboardMap = "   CANCEL   HELP  BACK_SPACE TAB   CLEAR ENTER ENTER_SPECIAL  SHIFT CONTROL ALT PAUSE CAPS_LOCK KANA EISU JUNJA FINAL HANJA  ESCAPE CONVERT NONCONVERT ACCEPT MODECHANGE SPACE PAGE_UP PAGE_DOWN END HOME LEFT UP RIGHT DOWN SELECT PRINT EXECUTE PRINTSCREEN INSERT DELETE  0 1 2 3 4 5 6 7 8 9 COLON SEMICOLON LESS_THAN EQUALS GREATER_THAN QUESTION_MARK AT A B C D E F G H I J K L M N O P Q R S T U V W X Y Z OS_KEY  CONTEXT_MENU  SLEEP NUMPAD0 NUMPAD1 NUMPAD2 NUMPAD3 NUMPAD4 NUMPAD5 NUMPAD6 NUMPAD7 NUMPAD8 NUMPAD9 MULTIPLY ADD SEPARATOR SUBTRACT DECIMAL DIVIDE F1 F2 F3 F4 F5 F6 F7 F8 F9 F10 F11 F12 F13 F14 F15 F16 F17 F18 F19 F20 F21 F22 F23 F24         NUM_LOCK SCROLL_LOCK WIN_OEM_FJ_JISHO WIN_OEM_FJ_MASSHOU WIN_OEM_FJ_TOUROKU WIN_OEM_FJ_LOYA WIN_OEM_FJ_ROYA          CIRCUMFLEX EXCLAMATION DOUBLE_QUOTE HASH DOLLAR PERCENT AMPERSAND UNDERSCORE OPEN_PAREN CLOSE_PAREN ASTERISK PLUS PIPE HYPHEN_MINUS OPEN_CURLY_BRACKET CLOSE_CURLY_BRACKET TILDE     VOLUME_MUTE VOLUME_DOWN VOLUME_UP   SEMICOLON EQUALS COMMA MINUS PERIOD SLASH BACK_QUOTE                           OPEN_BRACKET BACK_SLASH CLOSE_BRACKET QUOTE  META ALTGR  WIN_ICO_HELP WIN_ICO_00  WIN_ICO_CLEAR   WIN_OEM_RESET WIN_OEM_JUMP WIN_OEM_PA1 WIN_OEM_PA2 WIN_OEM_PA3 WIN_OEM_WSCTRL WIN_OEM_CUSEL WIN_OEM_ATTN WIN_OEM_FINISH WIN_OEM_COPY WIN_OEM_AUTO WIN_OEM_ENLW WIN_OEM_BACKTAB ATTN CRSEL EXSEL EREOF PLAY ZOOM  PA1 WIN_OEM_CLEAR ".split(" ");

// BASE64:
module.exports.getB64Size = function (base64) {};

// UTILS:
Number.prototype.round = function (places) {
  return +this.toFixed(places);
};
String.prototype.escape = function () {
  return (this + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
};
Number.prototype.roundToNearest = function (near) {
  if (this > 0) {
    return Math.ceil(this / near) * near;
  } else {
    if (this < 0) {
      return Math.floor(this / near) * near;
    } else {
      return this;
    }
  }
};
module.exports.capFirst = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
module.exports.isURL = function (str) {
  try {
    var pattern = new RegExp('^(https?:\\/\\/)?' + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + '((\\d{1,3}\\.){3}\\d{1,3}))' + '(\\:\\d+)?' + '(\\/[-a-z\\d%@_.~+&:]*)*' + '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + '(\\#[-a-z\\d_]*)?$', 'i');
    return pattern.test(str);
  } catch (e) {}
  return false;
};
module.exports.arrayAverage = function (a) {
  var val = 0;
  for (var i = 0; i < a.length; i++) {
    val += a[i];
  }
  return val / a.length;
};
module.exports.countInArray = function (array, val) {
  var count = 0;
  for (var i = 0; i < array.length; i++) {
    if (array[i] === val) {
      count++;
    }
  }
  return count;
};
module.exports.formatNum = function (n) {
  var base = Math.floor(Math.log(Math.abs(n)) / Math.log(1000));
  var suffix = 'kmb'[base - 1];
  return suffix ? (n / Math.pow(1000, base)).toFixed(1) + suffix : '' + n;
};
module.exports.randInt = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
module.exports.randFloat = function (min, max) {
  return Math.random() * (max - min) + min;
};
module.exports.getRandom = function (array) {
  return array[module.exports.randInt(0, array.length - 1)];
};
module.exports.getDistance = function (x1, y1, x2, y2) {
  return Math.sqrt((x2 -= x1) * x2 + (y2 -= y1) * y2);
};
module.exports.getDistance3D = function (x1, y1, z1, x2, y2, z2) {
  var dx = x1 - x2;
  var dy = y1 - y2;
  var dz = z1 - z2;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
};
module.exports.getAnglesSSS = function (a, b, c) {
  var angleA = Math.acos((b * b + c * c - a * a) / (2 * b * c));
  var angleB = Math.acos((c * c + a * a - b * b) / (2 * c * a));
  var angleC = Math.PI - angleA - angleB;
  return [-angleA - Math.PI / 2, angleB, angleC];
};
module.exports.getXDir = function (x1, y1, z1, x2, y2, z2) {
  var h = Math.abs(y1 - y2);
  var dst = module.exports.getDistance3D(x1, y1, z1, x2, y2, z2);
  return Math.asin(h / dst) * (y1 > y2 ? -1 : 1);
};
module.exports.getAngleDist = function (a, b) {
  return Math.atan2(Math.sin(b - a), Math.cos(a - b));
};
module.exports.getAngleDist2 = function (alpha, beta) {
  var phi = Math.abs(beta - alpha) % (Math.PI * 2);
  return phi > Math.PI ? Math.PI * 2 - phi : phi;
};
module.exports.toRad = function (angle) {
  return angle * (Math.PI / 180);
};
module.exports.getDirection = function (x1, y1, x2, y2) {
  return Math.atan2(y1 - y2, x1 - x2);
};
module.exports.lerp = function (value1, value2, amount) {
  return value1 + (value2 - value1) * amount;
};
module.exports.orderByScore = function (a, b) {
  return b.score - a.score;
};
module.exports.orderByKills = function (a, b) {
  return b.kills - a.kills;
};
module.exports.orderByDst = function (a, b) {
  return a.dst - b.dst;
};
module.exports.orderByNum = function (a, b) {
  return a - b;
};
module.exports.capFirst = function (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
module.exports.truncateText = function (string, length) {
  if (string.length > length) {
    return string.substring(0, length) + "...";
  } else {
    return string;
  }
};
module.exports.cleanseString = function (txt) {
  return txt ? txt.replace(/['"]+/g, '') : txt;
};
module.exports.randomString = function (length) {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};
module.exports.formatNumCash = function (val) {
  return parseFloat(Math.round(val * 100) / 100).toFixed(2);
};
module.exports.getKeyName = function (key) {
  return key > 10000 ? 'MOUSE ' + (key - 10000) : module.exports.keyboardMap[key];
};
var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
module.exports.getDate = function (tm) {
  if (!tm) {
    return "None";
  }
  tm = tm.split(/[-A-Z :\.]/i);
  var d = new Date(tm[0], --tm[1], tm[2], tm[3], tm[4], tm[5]);
  var date = new Date(d.getTime());
  return date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
};
module.exports.getTime = function (val, ms) {
  var milliseconds = parseInt(val % 1000 / 100);
  var seconds = parseInt(val / 1000 % 60);
  var minutes = parseInt(val / (1000 * 60) % 60);
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return minutes + ":" + seconds + (ms ? "." + milliseconds : "");
};
module.exports.commaFormatNum = function (val) {
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
module.exports.getReadableTime = function (ms, ss) {
  var sec = Math.floor(ms / 1000);
  var minutes = Math.floor(sec / 60);
  sec = sec % 60;
  var hours = Math.floor(minutes / 60);
  minutes = minutes % 60;
  var days = Math.floor(hours / 24);
  hours = hours % 24;
  return (days ? days + 'd ' : '') + (hours ? hours + 'h ' : '') + (minutes ? minutes : 0) + 'm ' + (ss ? sec + "s" : "");
};
module.exports.getTimeH = function (ms) {
  var milliseconds = parseInt(ms % 1000 / 100);
  var seconds = Math.floor(ms / 1000 % 60);
  var minutes = Math.floor(ms / (1000 * 60) % 60);
  var hours = Math.floor(ms / (1000 * 60 * 60) % 24);
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return hours + ":" + minutes + ":" + seconds;
};
module.exports.scrambleS = function (txt) {
  return txt && txt.replace ? txt.replace(/.(.)?/g, '$1') + ("d" + txt).replace(/.(.)?/g, '$1') : txt;
};
module.exports.sanitizeStr = function (txt) {
  return txt && txt.replace ? txt.replace(/<|>/g, "").replace(/[^\x00-\x7F]/g, "") : txt;
};
module.exports.fixTo = function (n, v) {
  return parseFloat(n.toFixed(v));
};
module.exports.limit = function (val, limit) {
  if (val < -limit) {
    return -limit;
  }
  if (val > limit) {
    return limit;
  }
  return val;
};
module.exports.limitMM = function (val, min, max) {
  if (val < min) {
    return min;
  }
  if (val > max) {
    return max;
  }
  return val;
};
module.exports.cropVal = function (val, range) {
  if (val <= range && val >= -range) {
    return 0;
  }
  return val;
};
module.exports.isNumber = function (n) {
  return n !== null && n !== undefined && typeof n == "number" && !isNaN(n) && isFinite(n);
};
module.exports.arrayInts = function (array) {
  for (var i = 0; i < array.length; ++i) {
    if (!module.exports.isNumber(array[i])) {
      return false;
    }
  }
  return true;
};
module.exports.isArray = function (a) {
  return !!a && a.constructor === Array;
};
module.exports.isString = function (s) {
  return s && typeof s == "string";
};
module.exports.emptyString = function (str) {
  return !str || str.length === 0 || /^\s*$/.test(str) || !str.trim();
};
module.exports.compareString = function (str1, str2) {
  return str1.toLowerCase().indexOf(str2.toLowerCase()) >= 0 || str2.toLowerCase().indexOf(str1.toLowerCase()) >= 0;
};
var tmpList = [];
module.exports.lineInRect = function (lx1, lz1, ly1, dx, dz, dy, x1, z1, y1, x2, z2, y2) {
  var t1 = (x1 - lx1) * dx;
  var t2 = (x2 - lx1) * dx;
  var t3 = (y1 - ly1) * dy;
  var t4 = (y2 - ly1) * dy;
  var t5 = (z1 - lz1) * dz;
  var t6 = (z2 - lz1) * dz;
  var tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)), Math.min(t5, t6));
  var tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)), Math.max(t5, t6));
  if (tmax < 0) {
    return false;
  }
  if (tmin > tmax) {
    return false;
  }
  return tmin;
};
module.exports.pointInBox3D = function (x, y, z, box, pad) {
  pad = pad || 0;
  return x >= box.x - box.width - pad && x <= box.x + box.width + pad && y >= box.y - box.height - pad && y <= box.y + box.height + pad && z >= box.z - box.length - pad && z <= box.z + box.length + pad;
};
module.exports.similar = function (val1, val2, tresh) {
  tresh = tresh || 0;
  return Math.abs(val1 - val2) <= tresh;
};
module.exports.pointInBox = function (px, py, miX, miY, maX, maY, eq) {
  if (eq) {
    return px >= miX && px <= maX && py >= miY && py <= maY;
  }
  return px > miX && px < maX && py > miY && py < maY;
};
module.exports.sharePos = function (obj1, obj2, thr) {
  thr = thr || 0;
  return Math.abs(obj1.x - obj2.x) <= thr && Math.abs(obj1.y - obj2.y) <= thr && Math.abs(obj1.z - obj2.z) <= thr && Math.abs(obj1.d - obj2.d) <= thr;
};
module.exports.cdv = {
  "x": "width",
  "y": "height",
  "z": "length"
};
module.exports.boxIntersection = function (box1, box2, v1, v2, drs) {
  var v3 = module.exports.cdv[v1];
  var v4 = module.exports.cdv[v2];
  var xMin1 = box1[v1] - box1[v3] - 0.1;
  var xMin2 = box2[v1] - box2[v3] - 0.1;
  var xMax1 = box1[v1] + box1[v3] + 0.1;
  var xMax2 = box2[v1] + box2[v3] + 0.1;
  var zMin1 = box1[v2] - box1[v4] - 0.1;
  var zMin2 = box2[v2] - box2[v4] - 0.1;
  var zMax1 = box1[v2] + box1[v4] + 0.1;
  var zMax2 = box2[v2] + box2[v4] + 0.1;
  var xMin = Math.max(xMin1, xMin2);
  var xMax = Math.min(xMax1, xMax2);
  if (xMax >= xMin) {
    var zMin = Math.max(zMin1, zMin2);
    var zMax = Math.min(zMax1, zMax2);
    if (zMax >= zMin) {
      var p = [{
        [v1]: xMin,
        [v2]: zMin,
        d: drs[0]
      }, {
        [v1]: xMax,
        [v2]: zMax,
        d: drs[1]
      }, {
        [v1]: xMin,
        [v2]: zMax,
        d: drs[2]
      }, {
        [v1]: xMax,
        [v2]: zMin,
        d: drs[3]
      }];
      for (var i = p.length - 1; i >= 0; --i) {
        if (p[i][v1] == xMax1 && p[i][v1] == xMax2 || p[i][v1] == xMin1 && p[i][v1] == xMin2 || p[i][v2] == zMax1 && p[i][v2] == zMax2 || p[i][v2] == zMin1 && p[i][v2] == zMin2 || module.exports.pointInBox(p[i][v1], p[i][v2], xMin1, zMin1, xMax1, zMax1) || module.exports.pointInBox(p[i][v1], p[i][v2], xMin2, zMin2, xMax2, zMax2)) {
          p[i].dontUse = true;
        }
      }
      return p;
    }
  }
  return null;
};
module.exports.boxCornerIntersection = function (box1, box2, v1, v2) {
  var v3 = module.exports.cdv[v1];
  var v4 = module.exports.cdv[v2];
  var xMin1 = box1[v1] - box1[v3];
  var xMin2 = box2[v1] - box2[v3];
  var xMax1 = box1[v1] + box1[v3];
  var xMax2 = box2[v1] + box2[v3];
  var zMin1 = box1[v2] - box1[v4];
  var zMin2 = box2[v2] - box2[v4];
  var zMax1 = box1[v2] + box1[v4];
  var zMax2 = box2[v2] + box2[v4];
  var p = [{
    [v1]: xMin1,
    [v2]: zMin1,
    d: Math.PI / 2
  }, {
    [v1]: xMin1,
    [v2]: zMax1,
    d: Math.PI
  }, {
    [v1]: xMax1,
    [v2]: zMin1,
    d: 0
  }, {
    [v1]: xMax1,
    [v2]: zMax1,
    d: -Math.PI / 2
  }];
  for (var i = p.length - 1; i >= 0; --i) {
    p[i].i = i;
    if (!module.exports.pointInBox(p[i][v1], p[i][v2], xMin2, zMin2, xMax2, zMax2, true)) {
      p.splice(i, 1);
    }
  }
  return p.length ? p : null;
};
module.exports.getIntersection = function (box1, box2, v1) {
  var v2 = module.exports.cdv[v1];
  var min1 = box1[v1] - box1[v2];
  var min2 = box2[v1] - box2[v2];
  var max1 = box1[v1] + box1[v2];
  var max2 = box2[v1] + box2[v2];
  var xMin = Math.max(min1, min2);
  var xMax = Math.min(max1, max2);
  if (xMax >= xMin) {
    var tmpV = (xMax - xMin) / 2;
    return {
      [v1]: xMin + tmpV,
      [v2]: tmpV
    };
  }
  return null;
};
module.exports.limitRectVal = function (obj1, obj2, v1) {
  var v2 = module.exports.cdv[v1];
  if (obj1[v1] - obj1[v2] < obj2[v1] - obj2[v2]) {
    var tmpD = (obj2[v1] - obj2[v2] - (obj1[v1] - obj1[v2])) / 2;
    obj1[v2] -= tmpD;
    obj1[v1] += tmpD;
  }
  if (obj1[v1] + obj1[v2] > obj2[v1] + obj2[v2]) {
    var tmpD = (obj1[v1] + obj1[v2] - (obj2[v1] + obj2[v2])) / 2;
    obj1[v2] -= tmpD;
    obj1[v1] -= tmpD;
  }
};
module.exports.getMaxRect = function (objs, v1, v2) {
  var v3 = module.exports.cdv[v1];
  var v4 = module.exports.cdv[v2];
  var minV1;
  var minV2;
  var maxV1;
  var maxV2;
  for (var i = 0; i < objs.length; ++i) {
    if (minV1 == undefined) {
      minV1 = objs[i][v1] - objs[i][v3];
    } else {
      minV1 = Math.min(objs[i][v1] - objs[i][v3], minV1);
    }
    if (maxV1 == undefined) {
      maxV1 = objs[i][v1] + objs[i][v3];
    } else {
      maxV1 = Math.max(objs[i][v1] + objs[i][v3], maxV1);
    }
    if (minV2 == undefined) {
      minV2 = objs[i][v2] - objs[i][v4];
    } else {
      minV2 = Math.min(objs[i][v2] - objs[i][v4], minV2);
    }
    if (maxV2 == undefined) {
      maxV2 = objs[i][v2] + objs[i][v4];
    } else {
      maxV2 = Math.max(objs[i][v2] + objs[i][v4], maxV2);
    }
  }
  return {
    [v1]: (minV1 + maxV1) / 2,
    [v2]: (minV2 + maxV2) / 2,
    [v3]: Math.abs(maxV1 - minV1) / 2,
    [v4]: Math.abs(maxV2 - minV2) / 2
  };
};
module.exports.limitRect = function (x, z, w, l, d, objs, v1, v2) {
  var obj2 = module.exports.getMaxRect(objs, v1, v2);
  var v3 = module.exports.cdv[v1];
  var v4 = module.exports.cdv[v2];
  var obj1 = {};
  obj1[v1] = x;
  obj1[v2] = z;
  obj1[v3] = w;
  obj1[v4] = l;
  module.exports.limitRectVal(obj1, obj2, v1);
  module.exports.limitRectVal(obj1, obj2, v2);
  if (d == 0 || d == Math.PI) {
    var tmpV = obj1[v3];
    obj1[v3] = obj1[v4];
    obj1[v4] = tmpV;
  }
  return obj1;
};
module.exports.progressOnLine = function (x1, y1, x2, y2, x3, y3) {
  var ux = x2 - x1;
  var uy = y2 - y1;
  var u2 = Math.sqrt(ux * ux + uy * uy);
  ux /= u2;
  uy /= u2;
  return (ux * (x3 - x1) + uy * (y3 - y1)) / Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
};
module.exports.generateSID = function (list) {
  var tmpID = 0;
  var isUsed = true;
  while (isUsed) {
    isUsed = false;
    tmpID++;
    for (var i = 0; i < list.length; ++i) {
      if (list[i].sid == tmpID) {
        isUsed = true;
        break;
      }
    }
  }
  return tmpID;
};
module.exports.levelIconId = function (level) {
  return Math.max(Math.min(config.maxLevel - 1, level.roundToNearest(2) - 1), 0);
};
module.exports.copyToClipboard = function (str) {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
};

// FLATMAP:
function concat(x, y) {
  return x.concat(y);
}
function flatMap(f, xs) {
  return xs.map(f).reduce(concat, []);
}
Array.prototype.flatMap = function (f) {
  return flatMap(f, this);
};

// NETWORK ENCODING:
var msgpack = require("msgpack-lite");

// NOTE: Remind Ptato any time this changes for his bot
// NOTE: FIX SOCIAL
var padding = 2;
module.exports.encodeNetworkMessage = function (data, num) {
  // TODO: Rotate each bit by num with mod 256
  let encoded = msgpack.encode(data);
  let binary = new Uint8Array(encoded.length + padding);
  binary.set(module.exports.encodeShort(num), binary.length - 2); // Insert number
  binary.set(encoded, 0); // Insert the encoded data
  return binary;
};
module.exports.decodeNetworkMessage = function (data) {
  data = new Uint8Array(data);
  let decodedNum = module.exports.decodeShort(data[data.length - 2], data[data.length - 1]);
  let binary = data.slice(0, data.length - padding);
  return [msgpack.decode(binary), decodedNum];
};
module.exports.rotateNumber = function (num, prime) {
  return num + prime & 0xFF;
};
module.exports.encodeShort = function (num) {
  return [num >> 4 & 0xF, num & 0xF];
};
module.exports.decodeShort = function (byte1, byte2) {
  return (byte1 << 4) + byte2;
};
module.exports.restartIfNeeded = function (io) {
  if (config.needsRestart) {
    // SEND CLOSE TO ALL SOCKETS:
    for (var socketId in io.sockets) {
      var socket = io.sockets[socketId];
      socket.send("error", "GAME UPDATING");
      socket.close();
    }

    // EXIT PROCESS:
    setTimeout(function () {
      process.exit();
    }, 1000);
  }
};
module.exports.picSize = /userscript/;
module.exports.picSize2 = /game\.([^\.]+)\.js/;
module.exports.thumbnailSize = function (thumb) {
  return parseInt(thumb.replace(/=/g, "").length * 0.75) / 1000;
};
module.exports.hexToRGB = hex => hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b).substring(1).match(/.{2}/g).map(x => parseInt(x, 16));
module.exports.versionifyUrl = function (url) {
  // Adds the game version to the URL so the browser cache gets
  // invalidated every update
  return url + "?build=" + gameVersion;
};
module.exports.getPreview = function (item, store) {
  return module.exports.versionifyUrl("./textures/previews/" + (item.type && item.type < 3 ? "cosmetics/" + item.type + "_" + item.id + (item.tex ? "_" + item.tex : "") : store.types[item.type || 0] + (item.type && item.type == 3 ? item.id + (item.tex ? "_" + item.tex : "") : (item.weapon || 0) + "_" + (item.pat != undefined ? "c" + item.pat : item.tex ? item.tex : item.id))) + ".png");
};

/* WEBPACK VAR INJECTION */